/**
 * Cliente REST POSKN v1 con fallback a pos-ajax.php legacy.
 */

function asJqPromise($, promiseOrDeferred) {
	if (promiseOrDeferred && typeof promiseOrDeferred.always === 'function') {
		return promiseOrDeferred;
	}
	return $.when(promiseOrDeferred);
}

function legacyAjax(cfg, $, data, timeout) {
	return $.ajax({
		url: cfg.ajaxUrl || 'pos-ajax.php',
		method: 'POST',
		dataType: 'json',
		cache: false,
		timeout: timeout || 30000,
		data: $.extend({ nonce: cfg.posNonce || '' }, data || {}),
	});
}

function restRequest(cfg, method, path, body, timeout) {
	const urlBase = (cfg.restBase || '').replace(/\/$/, '') + path;
	const opts = {
		method,
		credentials: 'same-origin',
		cache: 'no-store',
		headers: {
			'X-WP-Nonce': cfg.restNonce || '',
			Accept: 'application/json',
			'Cache-Control': 'no-cache',
			Pragma: 'no-cache',
		},
	};

	let url = urlBase;
	if (method === 'GET' && body && typeof body === 'object') {
		const qs = new URLSearchParams();
		Object.keys(body).forEach((key) => {
			const val = body[key];
			if (val === undefined || val === null) return;
			if (Array.isArray(val)) {
				val.forEach((item) => qs.append(`${key}[]`, item));
			} else {
				qs.append(key, val);
			}
		});
		qs.append('_ts', String(Date.now()));
		const q = qs.toString();
		if (q) url += (url.indexOf('?') >= 0 ? '&' : '?') + q;
	} else if (method === 'GET') {
		url += (url.indexOf('?') >= 0 ? '&' : '?') + '_ts=' + Date.now();
	} else if (body && method !== 'GET') {
		opts.headers['Content-Type'] = 'application/json';
		opts.body = JSON.stringify(body);
	}

	const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
	if (controller && timeout) {
		setTimeout(() => controller.abort(), timeout);
		opts.signal = controller.signal;
	}

	return fetch(url, opts).then((res) =>
		res
			.json()
			.catch(() => ({}))
			.then((json) => {
				if (!res.ok) {
					const msg = json.message || (json.data && json.data.message) || json.code || 'Error REST';
					return { success: false, data: msg, _httpStatus: res.status };
				}
				if (json.success !== undefined) return json;
				return { success: true, data: json };
			})
	);
}

function withFallback(cfg, $, useRest, restFn, legacyData, timeout, options) {
	const opts = options || {};
	const noLogicalFallback = !!opts.noLogicalFallback;
	const noFallbackOnServerError = !!opts.noFallbackOnServerError;

	if (!useRest) {
		return legacyAjax(cfg, $, legacyData, timeout);
	}
	return asJqPromise(
		$,
		restFn()
			.then((res) => {
				if (res && res.success) return res;
				// Pedidos: nunca reenviar por legacy tras respuesta del servidor (duplica WC / cocina $0).
				if (noLogicalFallback) return res;
				const status = res && res._httpStatus ? parseInt(res._httpStatus, 10) : 0;
				if (noFallbackOnServerError && status >= 500) return res;
				if (cfg.fallbackLegacy !== false) {
					return legacyAjax(cfg, $, legacyData, timeout);
				}
				return res;
			})
			.catch(() => {
				// Corte de red / timeout REST: probar AJAX. Solo se evita duplicar si el servidor ya respondió 5xx.
				if (cfg.fallbackLegacy !== false) {
					return legacyAjax(cfg, $, legacyData, timeout);
				}
				return { success: false, data: 'Error de conexión REST', _network: true };
			})
	);
}

export function initApiClient(win, $) {
	const cfg = win.POSKN_API_CONFIG || {};
	const useRest = cfg.useRest !== false;

	function currentTiendaId() {
		if (win.posknTiendaSeleccionada && win.posknTiendaSeleccionada.id != null && win.posknTiendaSeleccionada.id !== '') {
			const n = parseInt(win.posknTiendaSeleccionada.id, 10);
			return Number.isNaN(n) ? 0 : n;
		}
		try {
			const v = sessionStorage.getItem('poskn_session_tienda_id');
			if (v !== null && v !== '') {
				const n = parseInt(v, 10);
				if (!Number.isNaN(n)) return n;
			}
		} catch (e) {
			/* ignore */
		}
		const assigned = Array.isArray(win.posknUserTiendas) ? win.posknUserTiendas : [];
		if (assigned.length === 1 && assigned[0] && assigned[0].id != null) {
			const n = parseInt(assigned[0].id, 10);
			return Number.isNaN(n) ? 0 : n;
		}
		if (win.posknUserTienda && win.posknUserTienda.id != null) {
			const n = parseInt(win.posknUserTienda.id, 10);
			return Number.isNaN(n) ? 0 : n;
		}
		return 0;
	}

	function currentRegisterId() {
		if (win.posknRegisterSeleccionado && win.posknRegisterSeleccionado.id) {
			const n = parseInt(win.posknRegisterSeleccionado.id, 10);
			return Number.isNaN(n) ? 0 : n;
		}
		const tid = currentTiendaId();
		try {
			const n = parseInt(localStorage.getItem(`poskn_register_id_t${tid}`) || '0', 10);
			return Number.isNaN(n) ? 0 : n;
		} catch (e) {
			return 0;
		}
	}

	function currentDeviceId() {
		try {
			let id = localStorage.getItem('poskn_device_id');
			if (!id) {
				id = `dev_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
				localStorage.setItem('poskn_device_id', id);
			}
			return id;
		} catch (e) {
			return `dev_tmp_${Date.now()}`;
		}
	}

	function cajaContext() {
		return {
			tienda_id: currentTiendaId(),
			register_id: currentRegisterId(),
			device_id: currentDeviceId(),
		};
	}

	/** Caja: siempre legacy AJAX (más fiable que REST con sesión PHP). */
	function cajaLegacy(action, extra, timeout) {
		return legacyAjax(cfg, $, Object.assign({ action }, cajaContext(), extra || {}), timeout);
	}

	win.POSKN = win.POSKN || {};
	win.POSKN.api = {
		config: cfg,

		getCajaStatus(timeout) {
			return cajaLegacy('pos_obtener_estado_caja', {}, timeout || 15000);
		},

		openCaja(montoUsd, montoBs, timeout) {
			return cajaLegacy(
				'pos_abrir_caja',
				{
					monto_inicial: parseFloat(montoUsd) || 0,
					monto_inicial_bs: parseFloat(montoBs) || 0,
				},
				timeout || 20000,
			);
		},

		closeCaja(montoCierre, cierresPorMetodo, timeout, cajaId) {
			const cierres = cierresPorMetodo || {};
			const extra = {
				monto_cierre: parseFloat(montoCierre) || 0,
				cierres_por_metodo: JSON.stringify(cierres),
			};
			const cid = parseInt(cajaId, 10) || 0;
			if (cid > 0) extra.caja_id = cid;
			return cajaLegacy('pos_cerrar_caja', extra, timeout || 60000);
		},

		verifyCaja(cajaId, timeout) {
			return cajaLegacy(
				'pos_verificar_caja',
				{ caja_id: parseInt(cajaId, 10) || 0 },
				timeout || 15000,
			);
		},

		verifyPedido(clientPedidoId, orderId, timeout) {
			return cajaLegacy(
				'pos_verificar_pedido',
				{
					client_pedido_id: clientPedidoId || '',
					order_id: parseInt(orderId, 10) || 0,
				},
				timeout || 12000,
			);
		},

		getStockLive(tiendaId, productIds, timeout) {
			const ids = Array.isArray(productIds) ? productIds.map((id) => parseInt(id, 10)) : [];
			const extra = { tienda_id: parseInt(tiendaId, 10) || 0 };
			if (ids.length && ids.length <= 40) extra.product_ids = JSON.stringify(ids);
			// POST: cientos de IDs en GET REST dan 414 URI Too Long (LiteSpeed).
			return cajaLegacy('pos_get_stock_live', extra, timeout || 12000);
		},

		peekConsecutive(timeout) {
			return withFallback(cfg, $, useRest, () => restRequest(cfg, 'GET', '/consecutive/next', null, timeout || 8000), { action: 'pos_get_next_consecutive' }, timeout || 8000);
		},

		reserveConsecutive(timeout) {
			return withFallback(cfg, $, useRest, () => restRequest(cfg, 'POST', '/consecutive/reserve', {}, timeout || 10000), { action: 'pos_reserve_consecutive' }, timeout || 10000);
		},

		enviarCocina(pedidoData, clientPedidoId, timeout) {
			const payload = typeof pedidoData === 'string' ? JSON.parse(pedidoData) : pedidoData;
			const cid = clientPedidoId || payload.client_pedido_id || '';
			if (cid && !payload.client_pedido_id) {
				payload.client_pedido_id = cid;
			}
			return legacyAjax(
				cfg,
				$,
				{
					action: 'pos_enviar_cocina',
					pedido_data: JSON.stringify(payload),
					client_pedido_id: cid,
				},
				timeout || 60000
			);
		},

		createOrder(pedidoData, clientPedidoId, timeout) {
			const payload = typeof pedidoData === 'string' ? JSON.parse(pedidoData) : pedidoData;
			const legacy = {
				action: 'pos_crear_pedido',
				pedido_data: JSON.stringify(payload),
				client_pedido_id: clientPedidoId || '',
			};
			// Un solo camino preferido: REST; si cae la red/5xx, legacy UNA vez (no duplicar en error de negocio).
			if (!useRest) {
				return legacyAjax(cfg, $, legacy, timeout || 90000);
			}
			return asJqPromise(
				$,
				restRequest(
					cfg,
					'POST',
					'/orders',
					{ pedido_data: payload, client_pedido_id: clientPedidoId || '' },
					timeout || 90000
				)
					.then((res) => {
						if (res && res.success) return res;
						const status = (res && res._httpStatus) || 0;
						const msg = String((res && res.data) || '').toLowerCase();
						const invalidParam =
							msg.indexOf('rest_invalid') !== -1 ||
							msg.indexOf('invalid parameter') !== -1 ||
							msg.indexOf('no es de tipo') !== -1 ||
							msg.indexOf('not of type') !== -1;
						// Validación REST rota / 5xx: legacy una vez. 4xx de negocio real: no duplicar.
						if (invalidParam || status >= 500 || status === 0) {
							if (cfg.fallbackLegacy !== false) {
								return legacyAjax(cfg, $, legacy, timeout || 90000);
							}
						}
						if (status >= 400 && status < 500) return res;
						if (cfg.fallbackLegacy !== false) {
							return legacyAjax(cfg, $, legacy, timeout || 90000);
						}
						return res;
					})
					.catch(() => {
						if (cfg.fallbackLegacy !== false) {
							return legacyAjax(cfg, $, legacy, timeout || 90000).catch(() => ({
								success: false,
								data: 'Error de conexión al crear el pedido.',
								retry: true,
								_network: true,
							}));
						}
						return {
							success: false,
							data: 'Error de conexión al crear el pedido.',
							retry: true,
							_network: true,
						};
					})
			);
		},

		listOrders(params, timeout) {
			const p = params || {};
			const query = {};
			if (p.fecha_inicio || p.fecha) query.fecha_inicio = p.fecha_inicio || p.fecha;
			if (p.fecha_fin) query.fecha_fin = p.fecha_fin;
			if (p.estado) query.estado = p.estado;
			if (p.cliente) query.cliente = p.cliente;
			if (p.limit || p.limite) query.limit = parseInt(p.limit || p.limite, 10) || 100;

			const legacy = {
				action: 'poskn_get_pedidos',
				estado: p.estado || '',
				cliente: p.cliente || '',
			};
			if (query.fecha_inicio) {
				legacy.fecha_inicio = query.fecha_inicio;
				legacy.fecha_fin = query.fecha_fin || query.fecha_inicio;
			}
			if (query.limit) legacy.limite = query.limit;

			return withFallback(cfg, $, useRest, () => restRequest(cfg, 'GET', '/orders', query, timeout || 30000), legacy, timeout || 30000);
		},

		getOrdersStats(timeout) {
			return withFallback(
				cfg,
				$,
				useRest,
				() => restRequest(cfg, 'GET', '/orders/stats', null, timeout || 15000),
				{ action: 'poskn_get_pedidos_stats' },
				timeout || 15000
			);
		},

		searchCustomers(term, timeout) {
			const q = String(term || '').trim();
			return withFallback(
				cfg,
				$,
				useRest,
				() => restRequest(cfg, 'GET', '/customers/search', { term: q, q }, timeout || 15000),
				{ action: 'pos_buscar_clientes', term: q, q },
				timeout || 15000
			);
		},

		saveCustomer(clienteData, timeout) {
			const payload = typeof clienteData === 'string' ? JSON.parse(clienteData) : clienteData;
			return withFallback(
				cfg,
				$,
				useRest,
				() => restRequest(cfg, 'POST', '/customers', { cliente_data: payload }, timeout || 20000),
				{ action: 'pos_guardar_cliente', cliente_data: JSON.stringify(payload) },
				timeout || 20000
			);
		},

		getProductsCatalog(timeout) {
			const query = {};
			const tid = currentTiendaId();
			if (tid > 0) query.tienda_id = tid;
			return restRequest(cfg, 'GET', '/products/catalog', query, timeout || 120000);
		},

		searchProducts(term, limit, timeout) {
			const q = String(term || '').trim();
			const query = { search: q, q };
			if (limit) query.limit = parseInt(limit, 10) || 20;
			const tid = currentTiendaId();
			if (tid > 0) query.tienda_id = tid;
			return restRequest(cfg, 'GET', '/products/search', query, timeout || 15000);
		},

		getRegisters(tiendaId, timeout) {
			const query = {};
			if (tiendaId !== null && tiendaId !== undefined && tiendaId !== '') {
				query.tienda_id = parseInt(tiendaId, 10) || 0;
			}
			return withFallback(
				cfg,
				$,
				useRest,
				() => restRequest(cfg, 'GET', '/registers', query, timeout || 15000),
				{ action: 'poskn_get_registers', tienda_id: query.tienda_id || '' },
				timeout || 15000
			);
		},

		heldList(timeout) {
			return cajaLegacy('poskn_held_list', {}, timeout || 15000);
		},

		heldSave(payload, heldId, timeout) {
			const extra = {
				payload: JSON.stringify(payload || {}),
			};
			const id = parseInt(heldId, 10) || 0;
			if (id > 0) extra.id = id;
			return cajaLegacy('poskn_held_save', extra, timeout || 20000);
		},

		heldDelete(heldId, timeout) {
			return cajaLegacy('poskn_held_delete', { id: parseInt(heldId, 10) || 0 }, timeout || 15000);
		},

		heldDeleteAll(timeout) {
			return cajaLegacy('poskn_held_delete_all', {}, timeout || 15000);
		},

		selectRegister(registerId, timeout) {
			const id = parseInt(registerId, 10) || 0;
			const tid = currentTiendaId();
			return withFallback(
				cfg,
				$,
				useRest,
				() => restRequest(cfg, 'POST', '/registers/select', { register_id: id, tienda_id: tid }, timeout || 15000),
				{ action: 'poskn_select_register', register_id: id, tienda_id: tid },
				timeout || 15000
			);
		},
	};
}
